import TileType from "./tileType";
import Option from "./option";
import DataAxis from "./dataAxis";

export enum DataTypes {
  Personnel = 1,
  Operator,
  Alarms,
  Events,
  Dashboard,
  CcTvEvents,
  Recorders,
  Cameras,
  Controllers,
  Netboxes,
  ManagementServers,
  Information,
  Incidents,
  Operators,
  Devices,
  Readers,
}

export default interface DataType {
  id: number;
  value: string;
  order: number;
  incrementLabel: string;
  supportedTileTypes?: TileType[];
  supportedReportTypes?: Option[];
  supportedXAxisTypes?: DataAxis[];
  supportedYAxisTypes?: DataAxis[];
}
